import { asCardFoil, type CardFoilId } from '../types/foil'

/** Prints a duelist can pin on their public profile. */
export const PROFILE_SHOWCASE_LIMIT = 6

export interface ProfileShowcaseSlot {
  cardId: string
  foil: CardFoilId
}

/**
 * Drops junk entries and caps the case. The same card and foil may fill
 * more than one slot; ownership is checked when the case is saved.
 */
export function parseProfileShowcase(raw: unknown): ProfileShowcaseSlot[] {
  let value = raw
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value)
    } catch {
      return []
    }
  }
  if (!Array.isArray(value)) return []
  const out: ProfileShowcaseSlot[] = []
  for (const item of value) {
    if (out.length >= PROFILE_SHOWCASE_LIMIT) break
    if (!item || typeof item !== 'object') continue
    const rec = item as { cardId?: unknown; foil?: unknown }
    const cardId = String(rec.cardId ?? '').trim()
    if (!cardId) continue
    out.push({ cardId, foil: asCardFoil(rec.foil) })
  }
  return out
}

export function showcaseSlotKey(slot: ProfileShowcaseSlot): string {
  return `${slot.cardId}:${slot.foil}`
}
